import React from "react"
import PropTypes from 'prop-types'
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap"
import LoaderButton from "../components/shared/LoaderButton"
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const Panel = styled.div`
  @media all and (min-width: 480px) {
    padding: 60px 0;
    > form {
      margin: 0 auto;
      max-width: 320px;
    } 
  }
  
  text-align: center;
   
`

function LoginPanel({ email, password, handleChange, handleSubmit, validateForm, isLoading, passwordResetRequired }) {
  return (
    passwordResetRequired ?
    <Panel>
      <p>A troca da senha é obrigatória</p>
      <div>
        <Link to="/forgotPassword" className="btn btn-info btn-lg">Alterar senha</Link>
      </div>
    </Panel>
    :    
    <Panel>
      <form onSubmit={handleSubmit}>
        <FormGroup controlId="email" bsSize="large">
          <ControlLabel>Email</ControlLabel>
          <FormControl
            autoFocus
            type="email"
            value={email}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup controlId="password" bsSize="large">
          <ControlLabel>Senha</ControlLabel>
          <FormControl
            value={password}
            onChange={handleChange}
            type="password"
          />
        </FormGroup>
        <LoaderButton
          block
          bsSize="large"
          disabled={!validateForm()}
          type="submit"
          isLoading={isLoading}
          text="Login"
          loadingText="Autenticando…"
        />
      </form>
    </Panel>
  )
}

LoginPanel.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  validateForm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  passwordResetRequired: PropTypes.bool,
}

export default LoginPanel
